import ReactSelect from 'react-select';

import { CircularProgress } from '@material-ui/core';
import { shade } from 'polished';
import styled, { css, keyframes } from 'styled-components';

interface ErrorMessageProps {
  hasError: boolean;
}

const shake = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  min-height: 16px;
  font-size: 14px;
  color: rgb(135, 134, 139);
  margin-bottom: 8px;
  pointer-events: none;
  user-select: none;
`;

export const ErrorMessage = styled.div<ErrorMessageProps>`
  position: relative;
  display: block;
  height: fit-content !important;
  background: transparent !important;
  margin-top: 0.4rem;
  transition: 0.3s ease-in-out;

  div {
    display: block;
    color: ${props => props.theme.error};
    font-style: italic;
    font-size: 0.75rem;
    text-transform: normal;
    pointer-events: none;
    user-select: none;
  }
`;

export const CircleProgressCustom = styled(CircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: ${props => props.theme.primaryColor}!important;
  }
`;

export const ReactSelectCustom = styled(ReactSelect)`
  .react-select--is-selected {
    background: #166649;
  }

  .react-select__control {
    transition: 0.3s ease-in-out;

    &:hover,
    &:active,
    &:visited {
      border-color: #c4c4c4;
    }

    &:focus-visible,
    &:focus-within,
    &:focus {
      border-color: #166649;
    }

    ${props =>
      props.hasError &&
      css`
        border-color: ${props => props.theme.error};
        animation: ${shake} 0.82s ease-out;

        &:hover {
          border-color: ${props => props.theme.error};
        }
      `}
  }

  .react-select__value-container {
    flex-wrap: nowrap !important;
    overflow: overlay;
  }

  .react-select__multi-value {
    background: ${props => props.theme.primaryColor};

    > div {
      color: #fff;
    }

    .react-select__multi-value__remove {
      &:hover {
        background: ${shade(0.2, '#166649')};
        cursor: pointer;
        transition: 0.3s ease-in-out;
      }
    }
  }

  .react-select__option {
    background: #fff;
    color: #555;
    transition: 0.3s ease-in-out;

    &:hover {
      background: rgba(0, 0, 0, 0.14);
      color: #555;
      fill: #555;
    }

    &:hover svg {
      color: #555;
      fill: #555;
    }
  }
`;
